import { EventIds } from '../../enums/EventIds.es.js';

var ApolloErrors = /*#__PURE__*/function (ApolloErrors) {
  ApolloErrors["Unauthenticated"] = "UNAUTHENTICATED";
  ApolloErrors["Unauthorized"] = "UNAUTHORIZED";
  ApolloErrors["InternalServerError"] = "INTERNAL_SERVER_ERROR";
  return ApolloErrors;
}({});
var getErrorHandler = function getErrorHandler(log) {
  return function (_ref) {
    var graphQLErrors = _ref.graphQLErrors,
      networkError = _ref.networkError;
    if (graphQLErrors) {
      graphQLErrors.forEach(function (error) {
        var message = error.message,
          extensions = error.extensions;
        var errorDefinition = "[GraphQL error]: ".concat(message);
        if (extensions) {
          switch (extensions.code) {
            case ApolloErrors.Unauthenticated:
              log.warn(errorDefinition, EventIds.ApolloAuthenticationsError, error);
              break;
            case ApolloErrors.Unauthorized:
              log.error(errorDefinition, EventIds.ApolloUnauthorizedError, error);
              break;
            case ApolloErrors.InternalServerError:
              log.error(errorDefinition, EventIds.ApolloInternalServerError, error);
              break;
            default:
              log.error(errorDefinition, EventIds.ApolloError, error);
              break;
          }
        } else {
          log.error(errorDefinition, EventIds.ApolloError, error);
        }
      });
    }
    if (networkError) {
      log.error("[Network error]: ".concat(networkError), EventIds.ApolloNetworkError, networkError);
    }
  };
};

export { ApolloErrors, getErrorHandler };
